import { render, staticRenderFns } from "./EditProfileItems.vue?vue&type=template&id=6a84321e&scoped=true"
import script from "./EditProfileItems.vue?vue&type=script&lang=js"
export * from "./EditProfileItems.vue?vue&type=script&lang=js"
import style0 from "./EditProfileItems.vue?vue&type=style&index=0&id=6a84321e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84321e",
  null
  
)

export default component.exports